const $             = require('jquery');
const _             = require('underscore');
const { icon }      = require('@fortawesome/fontawesome-svg-core');
const pkg           = require('@readcube/pkg').default;
const deps          = require('../deps');
const evtout        = require('../evtout');
const evtbus        = require('../evtbus');
const meta2item     = require('../util/meta2item');
const menu          = require('./sidenav');

const faIconOpts  = { classes: ['fa-icon icon-h-16'] };
const fa = {
  fileUpload: require('@fortawesome/pro-light-svg-icons/faFileUpload').definition,
  fileExport: require('@fortawesome/pro-light-svg-icons/faFileExport').definition
};

class CitationExport {
  constructor({ container, item, metadata, user, syncApi }) {
    this._item = item;
    this._user = user;
    this._meta = metadata.meta || {};
    this._container = container;
    this._syncApi = syncApi;
    this._elem = $(`
      <div class="export-content">
        <div class="citation-gen">
          <div class="loader-inner ball-pulse export-loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="button-wrap">
           <button class="action-btn" data-format="ris">
             <span>Export to RefMan (.ris)</span>
           </button>
         </div>
         <div class="button-wrap">
           <button class="action-btn" data-format="bib">
             <span>Export to BibTeX (.bib)</span>
           </button>
         </div>
      </div>
    `);

    menu.add({
      id: 'export',
      icon: fa.fileExport,
      title: 'Export Citation',
      render: _.memoize(() => this._render())
    });
  }

  _render() {
    const content = this._elem.find('.citation-gen');
    const attached = new Promise(resolve => {
      this._elem.on('attached', resolve);
    });

    if (!navigator.onLine) {
      content.empty();
    }

    const item = Object.assign({}, meta2item(this._meta), this._item);
    const getCollection = _.memoize(collectionId => {
      return this._syncApi.collections.get({ collectionId });
    });

    pkg.load('@readcube/citation-export-panel', deps['@readcube/citation-export-panel'])
      .then(CitationExportPanel => {
        const options = {
          container: content, item, syncApi: this._syncApi,
          history: { key: this._user?.id || 'anonymous' }
        };

        attached.then(async () => {
          const cep = await CitationExportPanel.CreateAndInit(options);
          content.find('.export-loader').remove();
          cep.evtout.on('copy', (e, text, html) => {
            evtout.trigger('copy-to-clipboard', [text, html]);
          });
          cep.evtout.on('edit-item', (e, item) => {
            evtout.trigger('open-in-library', [item]);
          });
        });
      }).catch(() => content.empty());


    this._elem.find('.action-btn').click(async function() {
      const collection = await getCollection(item.collection_id);
      const mapping = collection?.custom_type_schema || collection?.type_schema;
      const format = $(this).attr('data-format');
      evtbus.trigger('export-citation', [format, mapping, item]);
    });

    return this._elem.appendTo(this._container);
  }
}

module.exports = CitationExport;
